import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment";
import "moment-timezone";
import { BACKEND } from "../config/configEnvs";
import { months, years } from "../utils/rawData/dateValues";
import { FaCommentDollar, FaExternalLinkAlt, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import Modal from "../components/ui/Modal";
import PaginationItem from "../components/ui/components/Pagination";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import GenerarPagosTrabajadores from "../utils/automateFuncions/GenerarPagosTrabajadores";
import { formatDate } from "../utils/rawData/dateValues";
import EditButton from "../components/ui/components/EditButton";
import DeleteButton from "../components/ui/components/DeleteButton";
import DetailsButton from "../components/ui/components/DetailsButton";

function PagosTrabajadores() {

  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);

  const [status, setStatus] = useState("");

  const [totalPages, setTotalPages] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  
  const [payments, setPayments] = useState([]);
  const [incidences, setIncidences] = useState([]);
  const [selectedWorker, setSelectedWorker] = useState("");
  const [workers, setWorkers] = useState([]);

  // Imagenes
  const [openImageViwer, setOpenImageViewer] = useState(false); // Modal de imagen
  const [selectedImages, setSelectedImages] = useState([]);

  // Función para calcular días restantes hasta la fecha fin de contrato
  const calculateRemainingDays = (fechaFinContrato) => {
    if (!fechaFinContrato) return null;
    
    const today = moment().startOf('day');
    const endDate = moment(fechaFinContrato.split("T")[0]).startOf('day');
    const diffDays = endDate.diff(today, 'days');
    
    return diffDays;
  };

  // Función para obtener el color según los días restantes
  const getRemainingDaysColor = (days) => {
    if (days === null) return "text-gray-500";
    if (days < 0) return "text-red-600 font-bold";
    if (days <= 30) return "text-orange-600 font-semibold";
    if (days <= 90) return "text-yellow-600";
    return "text-green-600";
  };

  // Resumen de datos
  const getSummary = () => {
    const totalWorkers = payments.length;
    const totalPayroll = payments.reduce((acc, payment) => {
      const payroll = payment.worker.vinculoLaboral === "Planilla" ? (payment.worker.sueldo * 0.1137) : 0;
      return acc + payroll;
    }, 0);

    const totalDiscounts = payments.reduce((acc, payment) => {
      const workerIncidences = incidences.filter(i => i.trabajador.id === payment.worker.id);
      const discount = workerIncidences.reduce((acc, incidence) => {
        const descuento = parseFloat(incidence.descuento) || 0;
        return acc + descuento;
      }, 0);
      return acc + discount;
    }, 0);

    const totalAdvancePayments = payments.reduce((acc, payment) => {
      return acc + (payment.advancePayment || 0);
    }, 0);

    const totalSalaries = payments.reduce((acc, payment) => {
      return acc + payment.worker.sueldo;
    }, 0);

    const totalToPay = payments.reduce((acc, payment) => {
      // Solo sumar si el pago no está marcado como pagado
      if (payment.status !== "Pagado") {
        const workerIncidences = incidences.filter(i => i.trabajador.id === payment.worker.id);
        const discount = workerIncidences.reduce((acc, incidence) => {
          const descuento = parseFloat(incidence.descuento) || 0;
          return acc + descuento;
        }, 0);
        const payroll = payment.worker.vinculoLaboral === "Planilla" ? (payment.worker.sueldo * 0.1137) : 0;
        const advancePayment = payment.advancePayment || 0;
        return acc + (payment.worker.sueldo - advancePayment - payroll - discount);
      }
      return acc;
    }, 0);

    return {
      totalWorkers,
      totalPayroll,
      totalDiscounts,
      totalAdvancePayments,
      totalSalaries,
      totalToPay,
      averageSalary: totalSalaries / totalWorkers,
      averageToPay: totalToPay / totalWorkers
    };
  };

  const getWorkers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?where[activo][equals]=true&limit=0`);
      setWorkers(response.data.docs);
    } catch (error) {
      return false
    }
  }

  const getPayments = async () => {
    try {
      setLoading(true);

      let url = `${BACKEND}/api/pagosTrabajadores?limit=0`;

      if (month) {
        url += `&where[month][equals]=${month}`;
      }
      if (year) {
        url += `&where[year][equals]=${year}`;
      }
      if (selectedWorker) {
        url += `&where[worker][equals]=${selectedWorker}`;
      }
      if (status) {
        url += `&where[status][equals]=${status}`;
      }

      const response = await axios.get(url, {withCredentials: true});

      setTotalPages(response.data.totalPages);
      setTotalDocs(response.data.totalDocs);
      setPayments(response.data.docs);

    } catch (error) {
      toast.error("Error al obtener los pagos:" + error);
    } finally {
      setLoading(false);
    }
  }

  const getIncidences = async () => {
    try {
      let url = `${BACKEND}/api/incidencias?limit=0`;

      if (month) {
        url += `&where[month][equals]=${month}`;
      }
      if (year) {
        url += `&where[year][equals]=${year}`;
      }
      if (selectedWorker) {
        url += `&where[trabajador][equals]=${selectedWorker}`;
      }

      const response = await axios.get(url, {withCredentials: true});

      setIncidences(response.data.docs);
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener las incidencias:" + error);
      return false
    }
  }
  
  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  useEffect(() => {
    getPayments();
    getWorkers()
    getIncidences()
  }, []);

  useEffect(() => {
    getPayments();
  }, [selectedWorker, month, year, status, page, limit]);

  useEffect(() => {
    getIncidences()
  }, [selectedWorker, month, year, status]);

  // Handlers de modal

  const handleOpenImageModal = (register) => {
    setSelectedImages(register.images);
    setOpenImageViewer(true);
  };

  const handleCloseImageModal = () => {
    setOpenImageViewer(false);
    setSelectedImages([]); // Limpia el registro seleccionado
  };

  const handleDelete = async (register) => {
    const confirmed = window.confirm(
      "¿Estás seguro de que deseas eliminar este registro?"
    );

    if (confirmed) {
      try {
        if (register.images && register.images.length) {
          await Promise.all(
            register.images.map(async (image) => {
              try {
                await axios.delete(
                  `${BACKEND}/api/imagenesPagosTrabajadores/${image.id}`
                );
              } catch (deleteError) {
                toast.warning(
                  `Error al eliminar imagen con ID ${image.id}:`,
                  deleteError
                );
              }
            })
          );
        }

        const response = await axios.delete(
          `${BACKEND}/api/pagosTrabajadores/${register.id}`
        );
        getPayments();
        toast.success("Registro eliminade exitosamente");
      } catch (error) {
        console.error("Error al eliminar el registro: ", error);
        toast.error("Error al eliminar el registro");
      }
    }
  };

  const colorMapStatus = {
    "Pendiente": "text-red-500 font-bold",
    "Adelanto": "text-green-500 font-bold",
    "Pagado": "text-blue-500 font-bold",
  }

  const colorBgStatus = {
    "Pendiente": "bg-red-50",
    "Adelanto": "bg-green-50",
    "Pagado": "bg-blue-50",
  }

  return (
    <div className="flex flex-col h-screen w-full">

      <Modal
        onClose={() => handleCloseImageModal()}
        activeModal={openImageViwer}
        title={`Imagen Pago`}
        centered
      >
        <div className="max-h-[600px] overflow-y-auto">
          {selectedImages?.map((image, index) => (
            <div className="gap-4 p-4">
              <div key={image.id} className="relative">
                {["image/jpeg", "image/jpg", "image/png"].includes(
                  image.mimeType
                ) && (
                  <>
                    <img
                      src={image.url}
                      alt={`Imagen de venta`}
                      className="w-full h-auto object-cover rounded-md shadow-md"
                    />
                    <a
                      href={image.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="absolute top-2 right-2 bg-white bg-opacity-75 text-black p-1 rounded-full"
                    >
                      <FaExternalLinkAlt />
                    </a>
                  </>
                )}
                {image.mimeType === "application/pdf" && (
                  <>
                    <embed
                      src={image.url}
                      type="application/pdf"
                      className="w-full h-[40rem] rounded-md shadow-md"
                    />
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </Modal>

      {/* Header */}
      <div className="flex flex-row py-2 bg-gray-100">
        <div className="flex px-4 wflex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex items-center gap-4 p-4">
            <FaCommentDollar className="text-2xl text-gray-700" />
            <h2 className="text-2xl font-bold text-gray-700">
              Pagos Trabajadores
            </h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <Button
              variant="contained"
              onClick={() => GenerarPagosTrabajadores(month, year, getPayments)}
              endIcon={<AutoFixHighIcon />}
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                fontFamily: "poppins",
                whiteSpace: "nowrap",
                padding: "4px 24px",
                backgroundColor: "#ff6400",
                transform: "all",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "#bb4a03",
                },
              }}
            >
              Generar pagos
            </Button>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Trabajador:</span>
              <select
                value={selectedWorker}
                onChange={(e) => setSelectedWorker(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="">Todos</option>
                {workers.map((worker) => (
                  <option key={worker.id} value={worker.id}>
                    {worker.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <Link to="/home/pagos-trabajadores/nuevo-pago">
                <Button
                  variant="contained"
                  endIcon={<AddIcon />}
                  linkTo="/home/pagos-trabajadores/nuevo-pago"
                  sx={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    fontFamily: "poppins",
                    whiteSpace: "nowrap",
                    padding: "4px 24px",
                    backgroundColor: "#ff6400",
                    transform: "all",
                    animationDuration: "1000",
                    textTransform: "none",
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "#bb4a03",
                    },
                  }}
                >
                  Nuevo Pago
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      {/* Resumen */}
      <div className="flex bg-gray-100 mt-0.5 w-full">
        <div className="w-full items-center justify-center overflow-x-auto py-1 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row gap-8 min-w-max px-4 items-center justify-center">        
              
            <div className="flex flex-row gap-2 items-center justify-center">
              <span className="block text-xs truncate font-medium text-gray-900">
                Total de trabajadores:
              </span>
              <span className="block text-xs truncate font-medium text-gray-900">
                {getSummary().totalWorkers}
              </span>
            </div>
            <div className="flex flex-row gap-2 items-center justify-center">
              <span className="block text-xs truncate font-medium text-gray-900">
                Total AFP/ONP:
              </span>
              <span className="block text-xs truncate font-medium text-gray-900">
                S/. {getSummary().totalPayroll.toFixed(2)}
              </span>
            </div>
            <div className="flex flex-row gap-2 items-center justify-center">
              <span className="block text-xs truncate font-medium text-gray-900">
                Total descuentos:
              </span>
              <span className="block text-xs truncate font-medium text-red-500">
                S/. {getSummary().totalDiscounts.toFixed(2)}
              </span>
            </div>
            <div className="flex flex-row gap-2 items-center justify-center">
              <span className="block text-xs truncate font-medium text-gray-900">
                Total adelantos:
              </span>
              <span className="block text-xs truncate font-medium text-green-500">
                S/. {getSummary().totalAdvancePayments.toFixed(2)}
              </span>
            </div>
            <div className="flex flex-row gap-2 items-center justify-center">
              <span className="block text-xs truncate font-medium text-gray-900">
                Total sueldos:
              </span>
              <span className="block text-xs truncate font-medium text-gray-900">
                S/. {getSummary().totalSalaries.toFixed(2)}
              </span>
            </div>
            <div className="flex flex-row gap-2 items-center justify-center">
            <span className="block text-xs truncate font-medium text-gray-900">
              Total a pagar:
            </span>
            <span className="block text-xs truncate font-medium text-blue-500">
              S/. {getSummary().totalToPay.toFixed(2)}
            </span>
            </div>

          </div>
        </div>
      </div>

      {/* Filtros */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 justify-between w-full gap-10">
        <div className="flex flex-row gap-4 items-center justify-center w-full px-4">

          <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
            <span>Estado:</span>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
            >
              <option value="">Todos</option>
              <option value={"Pendiente"}>Pendiente</option>
              <option value={"Adelanto"}>Adelanto</option>
              <option value={"Pagado"}>Pagado</option>
            </select>
          </div>

          <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
            <span>Mes:</span>
            <select
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
            >
              <option value={""}>Todos</option>
              {months.map((month, index) => (
                <option key={index} value={index + 1}>
                  {month.label}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
            <span>Año:</span>
            <select
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
            >
              {years.map((year, index) => (
                <option key={index} value={year.value}>
                  {year.label}
                </option>
              ))}
            </select>
          </div>

        </div>
      </div>
      
      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loading ? (
            <LoadingScreen />
          ) : (
            payments.length == 0 ? (
              <NoDataScreen />
            ) : (
              <table className="w-full">
                <thead className="bg-white sticky top-0 z-20">
                  <tr className="text-gray-700 text-center text-[10px] font-bold">
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Acciones
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Imagen
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red sticky left-0">
                      Trabajador
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Puesto
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Fecha inicio contrato
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Fecha fin contrato
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Días restantes contrato
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Vínculo laboral
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Sueldo
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Fecha Pago
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Mes
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Año
                    </th>
                    <th className="px-2 py-3 truncate text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      AFP u ONP (11.37%)
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Incidencias
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Descuentos
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Comisión
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Adelanto
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Debe
                    </th>
                    <th className="px-2 py-3 truncate text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Total a pagar
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Estado
                    </th>
                  </tr>
                </thead>

                <tbody className="z-10">
                  {payments.map((register, index) => {

                    const workerIncidences = incidences.filter(i => i.trabajador.id === register.worker.id);

                    const discount = workerIncidences.reduce((acc, incidence) => {
                      const descuento = parseFloat(incidence.descuento) || 0;
                      return acc + descuento;
                    }, 0);
                    
                    const payroll = register.worker.vinculoLaboral === "Planilla" ? (register.worker.sueldo * 0.1137) : 0;
                    const commission = 0
                    const advancePayment = register.advancePayment ? register.advancePayment : 0;

                    const salary = register.worker.sueldo;
                    const ows = register.worker.sueldo - advancePayment;
                    const totalToPay = ows - payroll - discount + commission;

                    const remainingDays = calculateRemainingDays(register.worker?.fechaFinContrato);
                    const remainingDaysColor = getRemainingDaysColor(remainingDays);

                    return (
                      <tr key={register.id} className="text-xs py-3 w-full hover:bg-gray-100 transition-all duration-100">
                      
                        <td scope="row" className="px-4 py-3  text-center whitespace-nowrap border border-gray-300">
                          <div className="flex flex-row items-center justify-center gap-2">
                            <Link to={`/home/pagos-trabajadores/editar-pago/${register.id}`}>
                              <EditButton content="Editar pago" />
                            </Link>
                            <DeleteButton action={() => handleDelete(register)} content="Eliminar pago" />
                          </div>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <div className="flex items-center justify-center">
                            {register?.images?.length > 0 ? (
                              <DetailsButton action={() => handleOpenImageModal(register)} content="Ver imagen" />
                            ) : (
                              <button className="p-1.5 text-gray-500 rounded-md bg-gray-700 bg-opacity-10 flex items-center">
                                <FaEyeSlash className="text-xs" />
                              </button>
                            )}
                          </div>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300 sticky left-0 bg-white">
                          <span className="flex items-center justify-center">
                            {register.worker?.name}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {register.worker?.puesto}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {register.worker?.fechaInicioContrato ? formatDate(register.worker?.fechaInicioContrato?.split("T")[0]) : "-"}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {register.worker?.fechaFinContrato ? formatDate(register.worker?.fechaFinContrato?.split("T")[0]) : "-"}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {register.worker?.fechaFinContrato ? Math.ceil((new Date(register.worker?.fechaFinContrato) - new Date()) / (1000 * 60 * 60 * 24)) : 0}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {register.worker.vinculoLaboral}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            S/. {salary?.toFixed(2)}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {formatDate(register.datePayment.split("T")[0])}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {months[register.month - 1].label}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {register.year}
                          </span>
                        </td>

                        <td scope="row" className={`px-4 py-3 text-center whitespace-nowrap border border-gray-300 ${register.worker.vinculoLaboral === "Planilla" ? "text-black" : "text-gray-200"}`} >
                          <span className="flex items-center justify-center">
                            S/. {payroll?.toFixed(2)}
                          </span>
                        </td>

                        <td scope="row" className={`${workerIncidences.length > 0 ? "text-black" : "text-gray-200"} px-4 py-3 text-center whitespace-nowrap border border-gray-300`}>
                          <span className="flex items-center justify-center">
                            {workerIncidences.length}
                          </span>
                        </td>

                        <td scope="row" className={`px-4 py-3 text-center whitespace-nowrap border border-gray-300 ${discount > 0 ? "text-black" : "text-gray-200"}`}>
                          <span className={`flex items-center justify-center ${discount > 0 ? "text-red-500" : "text-gray-200"}`}>
                            S/. {discount?.toFixed(2)}
                          </span>
                        </td>

                        <td scope="row" className={`px-4 py-3 text-center whitespace-nowrap border border-gray-300 ${commission > 0 ? "text-black" : "text-gray-200"}`}>
                          <span className={`flex items-center justify-center ${commission > 0 ? "text-green-500" : "text-gray-200"}`}>
                            S/. {commission?.toFixed(2)}
                          </span>
                        </td>

                        <td scope="row" className={`px-4 py-3 text-center whitespace-nowrap border border-gray-300 ${advancePayment > 0 ? "text-black" : "text-gray-200"}`}>
                          <span className={`flex items-center justify-center ${advancePayment > 0 ? "text-black" : "text-gray-200"}`}>
                            S/. {advancePayment?.toFixed(2)}
                          </span>
                        </td>

                        <td scope="row" className={`px-4 py-3 text-center whitespace-nowrap border border-gray-300 ${totalToPay > 0 ? "text-black" : "text-gray-200"}`}>
                          <span className="flex items-center justify-center">
                            S/. {ows?.toFixed(2)}
                          </span>
                        </td>

                        <td scope="row" className={`px-4 py-3 text-center whitespace-nowrap border border-gray-300`}>
                          <span className="flex items-center font-bold justify-center">
                            S/. {totalToPay?.toFixed(2)}
                          </span>
                        </td>

                        <td scope="row" className={`px-4 py-3 text-center whitespace-nowrap border border-gray-300 ${colorBgStatus[register.status] || ""}`}>
                          <span className={`flex items-center justify-center ${colorMapStatus[register.status] || "text-gray-200"}`}>
                            {register.status || "-"}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )
          )
        }
      </div>
      
      {/* Paginador */}
      <PaginationItem
        actualDocs={payments.length}
        totalDocs={totalDocs}
        entity="pagos"
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />
    </div>
  );
}

export default PagosTrabajadores;
